import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./User.css";

export default function User() {
  const testimonials = [
    {
      title: "Great Hospitalization",
      description:
        "Dream Tours is the only way to go. We had the time of our life on our trip to the Ark. The customer service was wonderful & the staff was very helpful.",
      name: "Andrew Fetcher",
      location: "New York, United States",
      rating: 5.0,
      image: "https://via.placeholder.com/50",
    },
    {
      title: "Hidden Treasure",
      description:
        "I went on the Gone with the Wind tour, and it was my first multi-day bus tour. The experience was terrific, thanks to the friendly tour guides.",
      name: "Bryan Bradfield",
      location: "Cape Town, South Africa",
      rating: 5.0,
      image: "https://via.placeholder.com/50",
    },
    {
      title: "Easy to Find your Leisure Place",
      description:
        "Thanks for arranging a smooth travel experience for us. Our cab driver was polite, timely, and helpful. The team ensured making it a stress-free trip.",
      name: "Prajakta Sasane",
      location: "Paris, France",
      rating: 5.0,
      image: "https://via.placeholder.com/50",
    },
    {
      title: "Memorable Experience",
      description:
        "The team made our vacation unforgettable. Highly recommended for anyone looking for a great travel experience.",
      name: "John Doe",
      location: "Sydney, Australia",
      rating: 5.0,
      image: "https://via.placeholder.com/50",
    },
    {
      title: "Excellent Support",
      description:
        "The customer support was always available and ready to help. Made our trip so much easier.",
      name: "Jane Smith",
      location: "London, UK",
      rating: 5.0,
      image: "https://via.placeholder.com/50",
    },
  ];

  return (
    <div className="user-section">
      <h2 className="user-title">
        What’s Our <span className="highlight-user">User</span> Says
      </h2>
      <p className="user-description">
        We’re a team of explorers, innovators, and customer-focused professionals
        who are passionate about making travel easy and accessible for everyone.
      </p>

      <Swiper
  modules={[Navigation]}
  navigation
  spaceBetween={20} // Space between cards
  slidesPerView={3} // Default for larger screens
  breakpoints={{
    850: {
      slidesPerView: 3, 
    },
    768: {
      slidesPerView: 1, // Tablet
    },
    480: {
      slidesPerView: 1, // Mobile
    },
    0: {
      slidesPerView: 1, // Smaller screens
    },
  }}
  observer={true} // Force Swiper to observe changes
  observeParents={true}
  className="testimonial-slider"
>

  {testimonials.map((testimonial, index) => (
    <SwiperSlide key={index} className="testimonial-slide">
      <div className="testimonial-card">
        <h3 className="testimonial-title">{testimonial.title}</h3>
        <p className="testimonial-description">{testimonial.description}</p>
        <hr className="user-line" />
        <div className="testimonial-user-info">
          <img
            src={testimonial.image}
            alt={testimonial.name}
            className="testimonial-user-image"
          />
          <div>
            <p className="testimonial-name">{testimonial.name}</p>
            <p className="testimonial-location">{testimonial.location}</p>
          </div>
          <span className="testimonial-rating">{testimonial.rating}</span>
        </div>
      </div>
    </SwiperSlide>
  ))}
</Swiper>


    </div>
  );
}